import React from 'react'

const HomePage = () => {
  return (
    <div>Support HomePage</div>
  )
}

export default HomePage